A signal that an action has been performed on the SEEK platform that may be of interest to an integration partner.

Events can be delivered via:

- Webhook, using the `createWebhookSubscription` mutation
- GraphQL polling, using the paginated `events` query
